<div class="renderer-container" (click)="$event.stopPropagation()">

  <mat-checkbox [checked]="state === stateEnums.ALL"
                (change)="update()"
  ></mat-checkbox>

</div>
